import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './Header.css';
import logo from '../asset/Images/logo.png';

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const SCROLL_UP_THRESHOLD = 300;
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleNavClick = (path) => {
    navigate(path);

    // Close the menu if it's open
    setIsMenuOpen(false);
  };

  useEffect(() => {
    const categorySection = document.querySelector('.category-menu-wrapper');
    if (categorySection && location.pathname === '/order') {
      categorySection.style.top = isVisible ? '100px' : '0';
      categorySection.style.transition = 'top 0.5s';
    }
  }, [isVisible, location.pathname]);

  useEffect(() => {
    const handleScroll = () => {
      if (location.pathname === '/order') {
        const currentScrollY = window.scrollY;
        let distanceScrolled = 0;

        if (currentScrollY === 0) {
          setIsVisible(true);
        } else {
          const isScrollingDown = currentScrollY > lastScrollY;

          if (isScrollingDown) {
            setIsVisible(false);
          } else {
            distanceScrolled += lastScrollY - currentScrollY;
            if (distanceScrolled >= SCROLL_UP_THRESHOLD) {
              setIsVisible(true);
              distanceScrolled = 0;
            }
          }
        }

        setLastScrollY(currentScrollY);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [lastScrollY, location.pathname]);

  useEffect(() => {
    if (['/', '/checkout', '/menu', '/contact'].includes(location.pathname)) {
      setIsVisible(true);
    }
  }, [location.pathname]);

  return (
    <header className={`${isVisible ? 'header' : 'header-disable'}`}>
      <nav className="navbar">
        {/* Logo */}
        <div className="navbar-brand">
          <span className="brand-logo" onClick={() => handleNavClick('/')}>
            <img src={logo} alt="logo" className='header-logo' />
          </span>
        </div>

        {/* Menu */}
        <div className={`navbar-menu ${isMenuOpen ? 'show-menu' : ''}`}>
          <ul className="nav-links">
            <li><span onClick={() => handleNavClick('/')}>Home</span></li>
            <li><span onClick={() => handleNavClick('/menu')}>Menu</span></li>
            <li><span onClick={() => handleNavClick('/order')}>Order</span></li>
            <li><span onClick={() => handleNavClick('/checkout')}>Checkout</span></li>

            <li><span onClick={() => handleNavClick('/contact')}>Contact</span></li>
          </ul>
        </div>

        <div className='btn-wrapper'>
          <button className='order-btn' onClick={() => handleNavClick('/order')}>Order Now</button>

        </div>

        {/* Toggle Button */}
        <button className="menu-toggle" onClick={toggleMenu}>
          ☰
        </button>
      </nav>
    </header>
  );
};

export default Header;
